import { BooleanColumn, StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import dayjs from 'dayjs';

export const COL_NAMES_BANK_DETAILS = {
	accountHolderName: 'accountHolderName',
	accountNumber: 'accountNumber',
	validatedAccountHolderName: 'validatedAccountHolderName',
	updatedAt: 'updatedAt',
	deactivationReason: 'deactivationReason',
	createdAt: 'createdAt',
	validationSource: 'validationSource',
	isValid: 'isValid',
	isActive: 'isActive',
	ifscCode: 'ifscCode'
};

export const columnConfigsBankDetails = [
	StringColumn({
		title: 'Account Holder Name',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.accountHolderName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Account Number',
		maxWidth: 200,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.accountNumber] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Validated Account Holder Name',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.validatedAccountHolderName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Ifsc Code',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.ifscCode] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Validation Source',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.validationSource] || EMPTY_STRING
	}),
	BooleanColumn({
		title: 'Is Valid',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.isValid]
	}),
	BooleanColumn({
		title: 'Is Active',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.isActive]
	}),
	StringColumn({
		title: 'Deactivation Reason',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES_BANK_DETAILS.deactivationReason] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			dayjs(new Date(data[COL_NAMES_BANK_DETAILS.createdAt])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	}),
	StringColumn({
		title: 'Updated At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			dayjs(new Date(data[COL_NAMES_BANK_DETAILS.updatedAt])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	})
];

export const COL_NAMES_UPI_DETAILS = {
	vpaName: 'vpaName',
	upiId: 'upiId',
	updatedAt: 'updatedAt',
	deactivationReason: 'deactivationReason',
	createdAt: 'createdAt',
	validationSource: 'validationSource',
	isValid: 'isValid',
	isActive: 'isActive'
};

export const columnConfigsUpiDetails = [
	StringColumn({
		title: 'VPA Name',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.vpaName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'UPI Id',
		maxWidth: 200,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.upiId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Validation Source',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.validationSource] || EMPTY_STRING
	}),
	BooleanColumn({
		title: 'Is Valid',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.isValid]
	}),
	BooleanColumn({
		title: 'Is Active',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.isActive]
	}),
	StringColumn({
		title: 'Deactivation Reason',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES_UPI_DETAILS.deactivationReason] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			dayjs(new Date(data[COL_NAMES_UPI_DETAILS.createdAt])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	}),
	StringColumn({
		title: 'Updated At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			dayjs(new Date(data[COL_NAMES_UPI_DETAILS.updatedAt])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	})
];
